// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"eX-z","upvoteIcon":"fX-z","downvoteIcon":"gX-z","feedbackIcon":"hX-z"};